// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","PersonHero":"PersonHero","background":"background","gradient":"gradient","content":"content","infoGroup":"infoGroup","personHeroLeft":"personHeroLeft","personHeroRight":"personHeroRight","name":"name","date":"date","location":"location","extras":"extras","shares":"shares","icons":"icons","facebook":"facebook","twitter":"twitter","email":"email","search":"search","forestlawnView":"forestlawnView PersonHero"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/PersonHero/css/PersonHero.styl
// module id = 1596
// module chunks = 0